import React from 'react';
import PropTypes from 'prop-types';

export const SvgPhone = ({ width, height, stroke = '#000000' }) => (
  <svg width={width || '16px'} height={height || '16px'} viewBox="0 0 16 16" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g transform="translate(-211.000000, -442.000000)" stroke={stroke} strokeWidth="2">
        <g transform="translate(210.000000, 435.000000)">
          <g transform="translate(-3.000000, 3.000000)">
            <path d="M18.6666667,15.28 L18.6666667,17.28 C18.6681905,17.6554301 18.5113653,18.0141056 18.2347186,18.2679099 C17.9580718,18.5217143 17.5872426,18.6471254 17.2133333,18.6133333 C15.1618892,18.3904272 13.1913328,17.6894297 11.46,16.5666667 C9.84921875,15.5431092 8.48355743,14.1774479 7.46,12.5666667 C6.3333187,10.8274693 5.632162,8.84732971 5.41333333,6.78666667 C5.37964881,6.41391489 5.50418134,6.04416828 5.75651052,5.76774737 C6.0088397,5.49132646 6.36572949,5.33368579 6.74,5.33326779 L8.74,5.33326779 C9.4092427,5.32674656 9.97966723,5.81731165 10.0733333,6.48 C10.1577487,7.1200443 10.3142996,7.74848459 10.54,8.35333333 C10.7231567,8.84058335 10.60601,9.38987084 10.24,9.76 L9.39333333,10.6066667 C10.3423703,12.2756972 11.7243028,13.6576297 13.3933333,14.6066667 L14.24,13.76 C14.6101292,13.39399 15.1594166,13.2768433 15.6466667,13.46 C16.2515154,13.6857004 16.8799557,13.8422513 17.52,13.9266667 C18.1903751,14.0212402 18.68346,14.6031951 18.6666667,15.28 Z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

SvgPhone.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
